/* src/app/modules_v2/booking/locations/components/location-form/location-form.component.css */
.w-100 {
  width: 100%;
}
.mr-2 {
  margin-right: 8px;
}
.my-3 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.mt-3 {
  margin-top: 16px;
}
h3 {
  color: var(--cf-chrome);
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  margin-top: 8px;
}
mat-card,
.mat-mdc-card {
  margin: 20px;
}
/*# sourceMappingURL=location-form.component.css.map */
